export interface ProductSalesOrderHistory {
  id: string;
  orderNo: string;
  orderDate: Date;
  customerKey: string;
  customerName: string;
  customerOrderRef: string;
  orderQuantity: number;
  orderPrice: number;
  orderValue: number;
  orderSterlingValue: number;
  orderStatus: string;
  stockNo: string;
  despatchNoteNo: number;
  despatchQuantity: number;
  despatchDate: Date;
  invoiceNo: number;
  invoiceDate: Date;
  invoicePrice: number;
  currencyCode: string;
  currencySymbol: string;
  deliveryAddress: string;
}
